import { AlertTriangleIcon, WrenchIcon } from "lucide-react";
import { Can } from "@/features/auth/components/Can";
import { ACTIONS } from "@/constants/roles";
import type { OverdueRental } from "../types/dashboard.types";

interface OperationalAlertsProps {
  overdueRentals: OverdueRental[];
  maintenanceCount: number;
  loading?: boolean;
}

export const OperationalAlerts = ({
  overdueRentals,
  maintenanceCount,
  loading,
}: OperationalAlertsProps) => {
  if (loading) return null;

  const hasOverdue = overdueRentals.length > 0;
  const hasMaintenance = maintenanceCount > 0;

  if (!hasOverdue && !hasMaintenance) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {hasOverdue && (
        <span className="inline-flex items-center gap-1.5 rounded-full border border-red-200 bg-red-50 px-3 py-1.5 text-xs font-medium text-red-700">
          <AlertTriangleIcon className="size-3 shrink-0" />
          {overdueRentals.length === 1
            ? "1 locação em atraso"
            : `${overdueRentals.length} locações em atraso`}
        </span>
      )}

      <Can permission={ACTIONS.stock.read}>
        {hasMaintenance && (
          <span className="inline-flex items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-3 py-1.5 text-xs font-medium text-amber-700">
            <WrenchIcon className="size-3 shrink-0" />
            {maintenanceCount === 1
              ? "1 peça em manutenção"
              : `${maintenanceCount} peças em manutenção`}
          </span>
        )}
      </Can>
    </div>
  );
};
